import React from "react";
import { Tooltip } from "antd";
import BoardAvatar from "../BoardAvatar/BoardAvatar";
import "./BoardAvatarStack.scss";

const BoardAvatarStack = ({
  members = [],
  max = 3,
  size = "sm",
  className = "",
}) => {
  if (!members.length) return null;

  const visible = members.slice(0, max);
  const overflowMembers = members.slice(max);
  const overflow = overflowMembers.length;
  const overflowNames = overflowMembers
    .map((member) => String(member.name || "").trim())
    .filter(Boolean)
    .join(", ");

  return (
    <div className={`pb-avatar-stack ${className}`.trim()}>
      {visible.map((member) => (
        <BoardAvatar
          key={member.id || member.userId}
          name={member.name}
          userId={member.id || member.userId}
          imageUrl={member.avatarUrl || member.imageUrl}
          size={size}
        />
      ))}
      {overflow > 0 && (
        <Tooltip
          title={overflowNames || `${overflow} more members`}
          mouseEnterDelay={0.15}
          placement="bottom"
        >
          <span className="pb-avatar-stack__more" aria-label={`${overflow} more members`}>
            +{overflow}
          </span>
        </Tooltip>
      )}
    </div>
  );
};

export default BoardAvatarStack;
